import api from '../../../../App/socket';

export const getUserProfilePhones = _id => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'Read',
        options: {
            limit: 1,
            where: { _id },
            attributes: ['person.phones.name', 'person.phones.phone'],
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_phones_requests/get_user_phones_request.js